import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';

import { jackPotStore } from '../../../../store/jackPotStore';

import { isMobile } from '../../../../core/helpers/isMobile';
import { getGameImages } from '../../../../core/helpers/getGameImages';

import JackPotSceneItemContent from './jackPotSceneItemContent';

const JackPotSceneItemWrapper = observer(
  ({ jackPotSymbols, jackpotIcons, jackPotItemEnum, symbolMoveContainerRef }) => {
    const { jackPotData, winCard, setWinCard } = jackPotStore;
    const { symbolsContainerBg } = useMemo(() => {
      return getGameImages();
    }, []);

    return (
      <Container name='JackPotSymbolsSectionContainer'>
        <Sprite
          anchor={0.5}
          x={isMobile() ? 270 : 717}
          y={isMobile() ? 463 : 442}
          texture={symbolsContainerBg}
        />
        {jackPotSymbols.map((itemIndex, index) => {
          const jackpotSceneItemInfo = jackPotData.find((el) => el.index === itemIndex);
          return (
            <JackPotSceneItemContent
              winCard={winCard}
              itemIndex={itemIndex}
              setWinCard={setWinCard}
              jackpotIcons={jackpotIcons}
              jackPotItemEnum={jackPotItemEnum}
              x={(isMobile() ? 126 : 569) + Math.floor(index % 3) * 143}
              y={(isMobile() ? 379 : 224) + Math.floor(index / 3) * 145}
              jackpotSceneItemInfo={jackpotSceneItemInfo}
              symbolMoveContainerRef={symbolMoveContainerRef}
            />
          );
        })}
      </Container>
    );
  }
);

export default JackPotSceneItemWrapper;
